import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthServerBase } from '../utils/runtime';

const AUTH_SERVER = getAuthServerBase();

function ModifierProfilPro() {
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    phone: '',
    clinic_name: '',
    license_number: '',
    birth_date: ''
  });

  const navigate = useNavigate();

  // Récupère l'utilisateur via /me
  useEffect(() => {
    fetch(`${AUTH_SERVER}/me`, { credentials: 'include' })
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data => setUser(data.user || data))
      .catch(() => navigate('/connexion'));
  }, [navigate]);

  // Charge les données de profil du professionnel
  useEffect(() => {
    if (!user?.email) return;

    fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${user.email}`)
      .then(res => res.json())
      .then(info => {
        setForm({
          first_name: info.first_name || '',
          last_name: info.last_name || '',
          phone: info.phone || '',
          clinic_name: info.clinic_name || '',
          license_number: info.license_number || '',
          birth_date: info.birth_date ? info.birth_date.split('T')[0] : ''
        });
      });
  }, [user]);

  const handleChange = (e) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user?.email) return;

    const resUser = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${user.email}`);
    const fullUser = await resUser.json();
    const id = fullUser.user_id;

    try {
      const res = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          user_type: 'professional',
          email: user.email
        })
      });

      if (res.ok) {
        alert('Profil mis à jour !');
        navigate('/professional/dashboard');
      } else {
        alert('Erreur lors de la mise à jour');
      }
    } catch (err) {
      console.error('Erreur:', err);
    }
  };

  if (!user) return <p>Chargement...</p>;

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Modifier mon profil professionnel</h2>
      <form onSubmit={handleSubmit}>
        <label>Prénom :
          <input type="text" name="first_name" value={form.first_name} onChange={handleChange} />
        </label><br />
        <label>Nom :
          <input type="text" name="last_name" value={form.last_name} onChange={handleChange} />
        </label><br />
        <label>Téléphone :
          <input type="text" name="phone" value={form.phone} onChange={handleChange} />
        </label><br />
        <label>Date de naissance :
          <input type="date" name="birth_date" value={form.birth_date} onChange={handleChange} />
        </label><br />
        <label>Clinique :
          <input type="text" name="clinic_name" value={form.clinic_name} onChange={handleChange} />
        </label><br />
        <label>Numéro de licence :
          <input type="text" name="license_number" value={form.license_number} onChange={handleChange} />
        </label><br />
        <button type="submit">Enregistrer</button>
      </form>
    </div>
  );
}

export default ModifierProfilPro;
